export default {
	name: "Landsbókasafn",
	format: "wav",
	connection: "ftp",
	audio: true,
	cover: true,
	meta: { format: "excel" },
	disableArticles: ["cd", "mp3cd"],
};
